import React from "react";

import { panelHeaderStyle } from "./styles";
import Paper from "./Paper";

const OnePanel = ({ title, style, children }) => (
  <Paper style={{ width: "100%", ...style }}>
    <h1
      style={{ ...panelHeaderStyle, marginBottom: "3em", fontWeight: "bold" }}
    >
      {title}
    </h1>
    {children}
  </Paper>
);

export default OnePanel;



// WEBPACK FOOTER //
// ./src/components/analysis/OnePanel.js